// extracted by mini-css-extract-plugin
export default {"csSearch":"CustomerServiceSearch_csSearch__-wI7c","searchInner":"CustomerServiceSearch_searchInner__JOCqD","csSearchForm":"CustomerServiceSearch_csSearchForm__iDvZW"};